(() => {
  const root = document.querySelector('.er-books');
  if (!root || root.dataset.motionBound === 'true') return;
  root.dataset.motionBound = 'true';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const authorsSection = root.querySelector('.er-books__authors');
  const authorLinks = Array.from(root.querySelectorAll('.er-books__author-link'));

  const revealAuthors = () => {
    if (!authorsSection) return;

    authorsSection.classList.add('is-revealed');

    authorLinks.forEach((link, index) => {
      const delay = reduceMotion ? 0 : Math.min(index, 9) * 55;
      link.style.transition =
        `opacity 500ms cubic-bezier(.2,.7,.2,1) ${delay}ms, ` +
        `transform 610ms cubic-bezier(.2,.72,.2,1) ${delay}ms, ` +
        `color .2s ease`;
      window.setTimeout(() => link.classList.add('is-revealed'), reduceMotion ? 0 : 35);
    });
  };

  if (reduceMotion) {
    root.classList.add('is-ready');
    revealAuthors();
    return;
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      root.classList.add('is-ready');
    });
  });

  if (authorsSection && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        revealAuthors();
        obs.unobserve(entry.target);
      });
    }, {
      threshold: 0.18,
      rootMargin: '0px 0px -7% 0px'
    });

    observer.observe(authorsSection);
  } else if (authorsSection) {
    revealAuthors();
  }
})();
